import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../helper/formatCurrency";

const OrderSuccess = ({ order, orderId, orderSummary, finalTotal, locale }) => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  const getLocalizedText = (field) => {
    if (!field) return "";
    if (typeof field === "string") return field;
    if (typeof field === "object")
      return field[i18n.language] || field.en || "";
    return "";
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-brand-50 to-brand-50 py-8">
      <div className="container mx-auto px-4 max-w-2xl">
        <div className="bg-white rounded-2xl shadow-2xl p-8 text-center">
          <div className="mb-6">
            <div className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-4">
              <svg
                className="w-12 h-12 text-green-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <h3 className="text-3xl font-bold text-gray-800 mb-2">
              {t("orderPlacedSuccessfully")}
            </h3>
            <p className="text-gray-600">
              Order ID: <strong>{order?.orderId || orderId}</strong>
            </p>
          </div>

          <div className="bg-brand-50 rounded-xl p-6 mb-6">
            <h3 className="font-semibold text-lg mb-4 text-gray-800">
              {t("orderSummary")}
            </h3>
            {orderSummary.map((item, index) => (
              <div
                key={index}
                className="flex justify-between items-center py-2 border-b border-brand-200 last:border-0"
              >
                <span className="text-gray-700">
                  {getLocalizedText(item.productName)} x {item.quantity}
                </span>
              </div>
            ))}
            <div className="mt-4 pt-4 border-t-2 border-brand-300 flex justify-between items-center">
              <span className="font-bold text-lg text-gray-800">
                {t("total")}
              </span>
              <span className="font-bold text-xl text-brand-600">
                {formatCurrency(finalTotal, locale)}
              </span>
            </div>
          </div>

          <p className="text-gray-600 mb-6">{t("redirectingToHome")}</p>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;
